// extracted by mini-css-extract-plugin
export default {"overlay":"vrxbDK","title":"IvIoaJ","text":"Q2vwr0"};